module.exports = __webpack_public_path__ + "img/fit.d90ce3d8.png";